module.exports = __webpack_public_path__ + "src/assets/fonts/Mohaji-Icons.f46384.svg";